exports.Dialog = {
    title: '弹窗',
    desc: [
        '弹窗是一种容器组件，可以嵌套包含子组件，也可以是简单文本信息。',
        '弹窗形式包括嵌入、弹出显示和模态显示。'
    ]
}

exports.DatePicker = {
    title: '日期范围选择器',
    desc: [
        '- 多维度：月、日、时、分',
        '- 可选时间范围',
        '- 可选时间跨度',
        '- 自定义快捷范围'
    ]
}


// WEBPACK FOOTER //
// ./src/index/terms.js